// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"5ae7bb7c","70":"a54f5205","113":"2a8bcb49","164":"f350d628","322":"a2e464f6","544":"35a357a1","868":"9d0b4a92","880":"288ae7dc","904":"2d88fa04","930":"844f7820"}[chunkId] + ".chunk.js";
};